import axios from "axios";

const clienteAxios = axios.create({
    baseURL:"https://impulsa-marketing.herokuapp.com"
});


export default clienteAxios;